export type ApiDonation = {
  id?: string;
  stripeEventId?: string;
  donorKey?: string | null;
  customerName?: string | null;
  address?: string | null;
  donationType?: string | null;
  displayDonorName?: boolean;
  customerEmail?: string | null;
  productId?: string | null;
  amount: number; // asume centavos; ajusta si viene en unidades
  currency: string; // "USD"
  likes?: number | null;
  isRecurring: boolean;
  date: string; // ISO
};

// Dominio mínimo (lo que guardamos en store)
export type Donation = {
  id: string;
  donorKey: string;
  donorName: string;
  address: string;
  donationType: string;
  showName: boolean;
  amountCents: number;
  currency: string;
  likes: number;
  isRecurring: boolean;
  dateISO: string;
};

// VM opcional para card (si quieres separar aún más)
export type DonationCardVM = {
  id: string;
  title: string;
  badge?: string | null;
  address: string;
  donationType: string;
  amountLabel: string;
  amountLabelDecimal?: string;
  likes: number;
  dateISO: string;
};

export const adaptDonation = (d: ApiDonation): Donation => {
  const id =
    d.id || d.stripeEventId || `${d.customerEmail ?? 'anon'}_${d.date}`;
  const donorKey =
    d.donorKey || d.customerEmail?.trim().toLowerCase() || id;
  const show = !!d.displayDonorName && !!d.customerName;
  return {
    id,
    donorKey,
    donorName: d.customerName as string,
    donationType: d.donationType as string,
    address: d.address as string,
    showName: show,
    amountCents: d.amount ?? 0,
    currency: d.currency ?? 'USD',
    likes: d.likes ?? 0,
    isRecurring: !!d.isRecurring,
    dateISO: d.date,
  };
};

function safeCurrency(n: number, currency: string, withDecimal: boolean = true) {
  try {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency,
      currencyDisplay: 'symbol',
      minimumFractionDigits: withDecimal ? 2 : 0,
      maximumFractionDigits: withDecimal ? 2 : 0,
    }).format(n);
  } catch {
    return `$${n.toFixed(withDecimal ? 2 : 0)}`;
  }
}

/* const amountLabelDecimal = safeCurrency(amount, x.currency); */

export const toCardVM = (x: Donation): DonationCardVM => {
  const amount = x.amountCents / 100;

  const amountLabel = safeCurrency(amount, x.currency, false);
  const amountLabelDecimal = safeCurrency(amount, x.currency, true);

  return {
    id: x.id,
    title: x.donorName,
    amountLabel,
    address: x.address,
    donationType: x.donationType,
    amountLabelDecimal,
    badge: x.isRecurring ? '2x' : null,
    likes: x.likes,
    dateISO: x.dateISO,
  };
};
